import { render, staticRenderFns } from "./PricingTableDesktop.vue?vue&type=template&id=321f892a&scoped=true&"
import script from "./PricingTableDesktop.vue?vue&type=script&lang=js&"
export * from "./PricingTableDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableDesktop.vue?vue&type=style&index=0&id=321f892a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f892a",
  null
  
)

export default component.exports